export enum enumReportSummaryType {
  SUM ='SUM',
  COUNT = 'COUNT',
  AVG = 'AVG'
}

export namespace enumReportSummaryType {
  export function values() {
    return Object.keys(enumReportSummaryType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
